import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BookingModal from "@/components/BookingModal";
import ScrollManager from "@/components/ScrollManager";
import { BookingProvider } from "@/context/BookingContext";

function FadeUpObserver() {
  const { pathname } = useLocation();
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.12 }
    );
    // Wait a tick so the new route's DOM is in place before querying.
    const t = setTimeout(() => {
      document.querySelectorAll(".fade-up:not(.visible)").forEach((el) => io.observe(el));
    }, 30);
    return () => {
      clearTimeout(t);
      io.disconnect();
    };
  }, [pathname]);
  return null;
}

export default function Layout() {
  return (
    <BookingProvider>
      <div className="vanda" id="top">
        <ScrollManager />
        <FadeUpObserver />
        <Header />
        <Outlet />
        <Footer />
        <BookingModal />
      </div>
    </BookingProvider>
  );
}
